import React from "react";

import { defaultState } from "./reducer/defaultState";
import { ticketingReducer } from "./reducer/index";

const TicketingContext = React.createContext();

const useTicketingContext = () => {
  const context = React.useContext(TicketingContext);
  if (context === undefined) {
    throw new Error(
      "useTicketingContext must be used within a TicketingContextProvider"
    );
  }
  return context;
};

const TicketingContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(ticketingReducer, defaultState);

  const value = { state, dispatch };
  return (
    <TicketingContext.Provider value={value}>
      {children}
    </TicketingContext.Provider>
  );
};

export { TicketingContextProvider, useTicketingContext };
